import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

export interface IMessage {
  title?: string;
  message: string;
}

@Component({
  selector: 'app-success-snack-bar',
  imports: [MatIconModule],
  templateUrl: './success-snack-bar.component.html',
  styleUrl: './success-snack-bar.component.css',
})
export class SuccessSnackBarComponent {
  data = inject<IMessage>(MAT_SNACK_BAR_DATA);
  snackBarRef =
    inject<MatSnackBarRef<SuccessSnackBarComponent>>(MatSnackBarRef);

  dismissSnackBar() {
    this.snackBarRef.dismiss();
  }
}
